"use client";

import { LeaderboardPlayer } from "@/types/leaderboards";
import { convertLetters } from "@/utils/letterConversion";
import { Link } from "react-router-dom";

interface LeaderboardRowProps {
    player: LeaderboardPlayer;
    rank: number;
}

const LeaderboardRow: React.FC<LeaderboardRowProps> = ({ player, rank }) => {
    return (
        <div className="grid grid-cols-[64px_1fr_auto] items-center gap-3 px-4 py-3 sm:px-6">
            {/* Rank */}
            <div className="font-prviking text-brand text-center text-xl sm:text-2xl">
                #{convertLetters(String(rank))}
            </div>

            {/* Shield Image */}
            <div className="flex min-w-0 items-center gap-3">
                <Link to={`/dashboard/players/${player.playerId}`}>
                    <img
                        src={
                            player.shield?.imageWithTagsUrl ||
                            player.shield?.imageUrl ||
                            "/no-shield.png"
                        }
                        alt={player.playerName}
                        className="h-11 w-11 rounded-full border-2 object-cover sm:h-12 sm:w-12"
                        style={
                            player.clanColor
                                ? { borderColor: player.clanColor }
                                : {}
                        }
                    />
                </Link>
                <Link to={`/dashboard/players/${player.playerId}`}>
                    <span className="font-prviking text-brand block truncate text-base sm:text-lg">
                        {convertLetters(player.playerName)}
                    </span>
                </Link>
                {player.clanTag && (
                    <span
                        className="font-garamond text-xs text-zinc-400 sm:text-sm"
                        style={
                            player.clanColor ? { color: player.clanColor } : {}
                        }
                    >
                        {player.clanTag}
                    </span>
                )}
            </div>

            {/* Value */}
            <div className="font-garamond text-brand text-lg sm:text-2xl">
                {player.value.toLocaleString()}
            </div>
        </div>
    );
};

export default LeaderboardRow;
